RivalIQ.apps.CompanyProfile.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const widgets = [
        {
            instanceId: 'alerts',
            widgetId: RivalIQ.enums.widgetTypes.ALERTS
        }
    ];

    curations.Alerts = Dashboard.models.Curation.mixin({
        mixins: {
            CompanySwitchable: Dashboard.mixins.CompanySwitchable,
            SingleWidget: Dashboard.mixins.SingleWidget
        },

        beforeFilters: [
            curations.filters.loadCompanies
        ],

        widgetsView: Dashboard.views.WidgetsFocus,
        companySets: false,
        page: RivalIQ.configuration.menus.getConfiguration().COMPANY_PROFILE,
        getExportTitle: function () {
            const me = this;
            return `${RivalIQ.props.companyName(me.getProps())} Alert Feed`;
        },
        getBasePath: function (overrides) {
            const me = this;
            const props = _.defaults(overrides, {
                companyId: me.getProp('companyId')
            });
            return me.router.resolveCurationRoute(me.id, props);
        },
        widgetDefinitions: widgets
    });
});
